export default __webpack_public_path__ + "static/media/everybyte.ca90aa8b.png";